import Vue from 'vue';
import VueRouter from 'vue-router';
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';

import PayApp from '@/modules/pay/PayApp';
import PayStatus from '@/modules/pay/PayStatus';
import payer from '@/modules/payer/router';
import OidcCallback from '@/pages/auth/OidcCallback';
import KitchenSummary from '@/pages/shop/summary/KitchenSummary';
import TodayOrder from '@/pages/shop/TodayOrder';
import UserSettings from '@/pages/UserSettings';
import store from '@/store';
import payee from './payee';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/oidc-callback',
      name: 'oidcCallback',
      component: OidcCallback,
    },
    {
      path: '/usersettings',
      component: UserSettings,
    },
    {
      path: '/pay/:id/:date/:hash',
      component: PayApp,
      props: true,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/client/pay',
      component: PayStatus,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/client/paid',
      component: PayStatus,
      meta: {
        isPublic: true,
      },
    },
    {
      path: '/payee/:payeeId/order/today',
      component: TodayOrder,
      props: true,
    },
    {
      path: '/payee/:payeeId/shop/:catalogId/kitchen',
      component: KitchenSummary,
      props: true,
    },
    payee,
    payer,
  ],
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidc'));

export default router;
